// extracted by mini-css-extract-plugin
module.exports = {"mainVideo":"MainVideo_mainVideo__1wx90","mainVideoHidden":"MainVideo_mainVideoHidden__aoemp"};